import React, { useEffect, useState } from "react";

interface TabProps {
  tabs: { title: string; content: React.ReactNode; disabled?: boolean }[];
  handleClickTab?: (index: number) => void;
  active: number;
  btnClass?: string;
  activeClass?: string;
  inActiveClass?: string;
}

const TabComponent: React.FC<TabProps> = ({ tabs, handleClickTab, active, btnClass, activeClass, inActiveClass }) => {
  const [activeTab, setActiveTab] = useState(active || 0);
  useEffect(() => {
    setActiveTab(active);
  }, [active]);
  const handleTabClick = (index: number, disabled?: boolean) => {
    if (!disabled) setActiveTab(index);
    if (handleClickTab) {
      handleClickTab(index);
    }
  };

  console.log(activeTab, "activeTab");
  
  return (
    <div className="w-full">
      <div className="text-center p-4">
        <ul className="flex justify-items-start">
          {tabs.map((tab, index) => (
            <li className="mr-2" key={index}>
              <button
                className={`inline-block px-4 font-medium ${btnClass ? btnClass : 'min-w-[160px] border-b-[3px] py-[10px] text-[14px]'} ${
                  index === activeTab
                    ? `${activeClass ? activeClass : 'text-[#FF6741] border-b-[#FF6741]'}`
                    : `${inActiveClass ? inActiveClass : 'text-[#111111] border-none'}`
                } ${tab.disabled ? "text-[#111111]" : ""}`}
                onClick={() => handleTabClick(index, tab.disabled)}
                disabled={tab.disabled}
              >
                {tab.title}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="p-4 w-full">{tabs[activeTab]?.content}</div>
    </div>
  );
};

export default TabComponent;
